<!-- @format -->
@if (canOpenAttainmentDetails) {
  <sis-study-notification-box
    [useFudisLink]="true"
    type="info"
    [tertiaryButtonText]="'PLAN.SHOW_ATTAINMENT_DETAILS'"
    (tertiaryClickAction)="openAttainmentDetailsModal()">
  </sis-study-notification-box>
}
